import { ImagePlus, Film, Music, Type, Copy } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { AddableLayerType } from '@/lib/layers/layerTypeConfig';

/**
 * Single source of truth for the "Add layer" menu rows, shared by the
 * toolbar menu (`AddLayerMenu`) and the context menus.
 */
export const LAYER_MENU_ITEMS: Array<{
  type: AddableLayerType;
  Icon: LucideIcon;
  labelKey: string;
}> = [
  { type: 'image', Icon: ImagePlus, labelKey: 'projectEditor.layers.addImage' },
  { type: 'video', Icon: Film, labelKey: 'projectEditor.layers.addVideo' },
  { type: 'audio', Icon: Music, labelKey: 'projectEditor.layers.addAudio' },
  { type: 'text', Icon: Type, labelKey: 'projectEditor.layers.addText' },
  { type: 'clip', Icon: Copy, labelKey: 'projectEditor.layers.addClip' },
];
